var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77825 10.4999H14.3333V14.2782H10.5551V18.055H6.77825V14.9865H3.70833V18.055H6.77825V21.8333H3V14.2782H6.77825V10.4999ZM6.77825 21.8333H10.5551V25.6115H14.3333V29.3884H6.77825V21.8333ZM14.3333 18.055H18.1116V21.8333H14.3333V18.055ZM21.8884 21.8333V25.6115H18.1116V21.8333H21.8884ZM21.8884 21.8333V18.055H25.6667V21.8333H21.8884Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2218 21.8333V18.055H29.445V14.2782H25.6667V10.4999H33.2218V14.2782H37.0001V21.8333H33.2218ZM33.2218 18.055H36.2918V14.9865H33.2218V18.055Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2218 21.8333V29.3884H25.6667V25.6116H29.445V21.8333H33.2218Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelscope);
export default __webpack_public_path__ + "static/media/modelscope.5ed71b37612ed8b12fcf1cd3342b7a80.svg";
export { ForwardRef as ReactComponent };